module.exports = __webpack_public_path__ + "img/social-id-uploaded-successfuly.90aa098e.svg";